<template>
    <!-- <div class="cont"> -->
    <!-- WYŁĄCZONO ETAP STAGÓW - ABY WŁĄCZYĆ TRZEBA POPRAWIĆ DANE W LINIACH OZNACZONYCH KOMENTARZAMI STG_DISABLED -->
    <div
        class="flpi"
        ref="flpi"
    >
        <div
            class="flpi-header"
            ref="header"
        >
            <div class="flpi-header-stepper">
                <div class="flpi-header-stepper__step">Krok {{ step - 1 }}:</div>
                <!-- STG_DISABLED -->
                <div class="flpi-header-stepper__stepname">
                    {{ STEP_LABELS[step] }}
                </div>
            </div>
            <div class="flpi-header-goback">
                <button
                    class="flpi-btn flpi-btn-primary"
                    v-if="step > 2"
                    @click="changeStep(step - 1)"
                >
                    <!-- STG_DISABLED -->
                    <span class="flpi-header-goback__name"> Cofnij </span>
                    <br />
                    <span class="flpi-header-goback__desc">
                        {{ STEP_GOBACK_DESCS[step] }}
                    </span>
                </button>
            </div>
        </div>
        <div class="flpi__container">
            <div class="flpi__display">
                <div
                    class="flpi-layer"
                    v-if="data_loaded"
                >
                    <!-- OBRAZ W TLE -->
                    <div
                        class="flpi-layer__image"
                        :class="{
                            'flpi-layer__image--blurred': step === 1
                        }"
                    >
                        <img :src="layer_image_src" />
                    </div>

                    <!-- CONTENT GŁÓWNY (SVG LUB COŚ INNEGO) -->
                    <transition
                        name="flpi-fade"
                        mode="out-in"
                    >
                        <div
                            class="flpi-layer__stages"
                            v-if="step === 1"
                        >
                            <div
                                class="flpi-layer-stage"
                                v-for="stage in stages"
                                :key="stage.id"
                            >
                                <div class="flpi-layer-stage__card">
                                    <div class="flpi-layer-stage__name">
                                        {{ stage.name }}
                                    </div>
                                    <div class="flpi-layer-stage__cta">
                                        <button
                                            class="flpi-btn flpi-btn-primary"
                                            :disabled="!stage.is_available"
                                            @click="
                                                _ => {
                                                    selected_stage = stage.id;
                                                    changeStep(2);
                                                }
                                            "
                                        >
                                            WYBIERZ
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="flpi-layer-apartment"
                            v-else-if="step === 5"
                            ref="apartment"
                        >
                            <div class="flpi-layer-apartment__header">
                                <h2 class="flpi-layer-apartment__name">
                                    Apartament {{ current_apartment.details.name }}
                                </h2>
                                <a
                                    class="flpi-layer-apartment__goback"
                                    @click="changeStep(4)"
                                >
                                    <svg
                                        style="width: 24px; height: 24px"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z"
                                        />
                                    </svg>
                                    Powrót do widoku piętra
                                </a>
                            </div>
                            <div
                                class="flpi-layer-apartment__details"
                                :class="{
                                    'flpi-layer-apartment__details--mobile': flpi_width <= 780
                                }"
                            >
                                <div
                                    class="flpi-layer-apartment__info"
                                    :class="{
                                        'flpi-layer-apartment__info--mobile': flpi_width <= 780
                                    }"
                                >
                                    <h4 class="flpi-layer-apartment__heading">Cechy apartamentu</h4>
                                    <div class="flpi-layer-apartment__props">
                                        <div
                                            class="flpi-layer-apartment__propcol"
                                            v-for="(prop, ix) in current_apartment_props"
                                            :key="ix"
                                        >
                                            <div class="flpi-layer-apartment-prop">
                                                <div class="flpi-layer-apartment-prop__name">
                                                    {{ prop.name }}
                                                </div>
                                                <div class="flpi-layer-apartment-prop__value">
                                                    {{ prop.value }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="flpi-layer-apartment__card"
                                    :class="{
                                        'flpi-layer-apartment__card--mobile': flpi_width <= 780
                                    }"
                                >
                                    <h4 class="flpi-layer-apartment__heading">Karta apartamentu</h4>
                                    <div class="flpi-layer-apartment-plan">
                                        <div class="flpi-layer-apartment-plan__image">
                                            <img
                                                :src="current_apartment.details.card_img"
                                                :alt="
                                                    'Plan apartamentu ' +
                                                    current_apartment.details.name
                                                "
                                            />
                                        </div>
                                        <a
                                            :href="current_apartment.details.card_pdf"
                                            class="flpi-layer-apartment-plan__btn"
                                            target="_blank"
                                            :download="
                                                'Karta apartamentu ' +
                                                current_apartment.details.name +
                                                '.pdf'
                                            "
                                        >
                                            <svg
                                                style="width: 24px; height: 24px"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z"
                                                />
                                            </svg>
                                            Pobierz kartę PDF
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="flpi-layer-apartment__similar"
                                v-if="current_apartment.similar_apartments.length > 0"
                            >
                                <h4 class="flpi-layer-apartment__heading">Podobne apartamenty</h4>
                                <div class="flpi-layer-apartment__simgrid">
                                    <div
                                        class="flpi-layer-apartment__simcol"
                                        :class="{
                                            'flpi-layer-apartment__simcol--mobile':
                                                flpi_width <= 780
                                        }"
                                        v-for="ap in current_apartment_similar_apartments"
                                        :key="ap.id"
                                    >
                                        <div
                                            class="flpi-layer-apartment-simap"
                                            @click="selectAnotherApartment(ap)"
                                        >
                                            <div class="flpi-layer-apartment-simap__name">
                                                Apartament {{ ap.details.name }}
                                            </div>
                                            <div class="flpi-layer-apartment-simap__prop">
                                                Budynek <span>{{ ap.details.building }}</span>
                                            </div>
                                            <div class="flpi-layer-apartment-simap__prop">
                                                Piętro
                                                <span>{{
                                                    ap.details.floor == "0"
                                                        ? "Parter"
                                                        : ap.details.floor
                                                }}</span>
                                            </div>
                                            <div class="flpi-layer-apartment-simap__prop">
                                                Powierzchnia
                                                <span>{{ ap.details.area }} m.kw.</span>
                                            </div>
                                            <div class="flpi-layer-apartment-simap__cta">
                                                Zobacz szczegóły
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <svg
                            class="flpi-layer__svg"
                            viewBox="0 0 1400 600"
                            v-else
                        >
                            <template v-if="step === 2">
                                <polygon
                                    v-for="building in buildings.filter(
                                        item => item.stage == selected_stage
                                    )"
                                    :key="building.id"
                                    :points="building.overlay_polygon_coords"
                                    class="flpi-svg__polygon"
                                    @mouseenter="
                                        showTooltip(`Budynek ${building.name}`, [
                                            `Dostępnych apartamentów: ${building.available_apartments}`
                                        ])
                                    "
                                    @mouseleave="hideTooltip"
                                    @mousemove="updateTooltipPosition"
                                    @click="
                                        _ => {
                                            selected_building = building.id;
                                            changeStep(3);
                                            hideTooltip();
                                        }
                                    "
                                />
                            </template>
                            <template v-if="step === 3">
                                <polygon
                                    v-for="floor in floors.filter(
                                        item => item.building == selected_building
                                    )"
                                    :key="floor.id"
                                    :points="floor.overlay_polygon_coords"
                                    class="flpi-svg__polygon"
                                    @mouseenter="
                                        showTooltip(`${floor.name}`, [
                                            `Liczba apartamentów: ${floor.apartments}`,
                                            `w tym dostępnych: ${floor.available_apartments}`
                                        ])
                                    "
                                    @mouseleave="hideTooltip"
                                    @mousemove="updateTooltipPosition"
                                    @click="
                                        _ => {
                                            selected_floor = floor.id;
                                            changeStep(4);
                                            hideTooltip();
                                        }
                                    "
                                />
                            </template>
                            <template v-if="step === 4">
                                <polygon
                                    v-for="apartment in apartments.filter(
                                        item => item.floor == selected_floor
                                    )"
                                    :key="apartment.id"
                                    :points="apartment.overlay_polygon_coords"
                                    class="flpi-svg__polygon flpi-svg__polygon--halfvisible"
                                    :class="{
                                        'flpi-svg__polygon--success': ['1', '2'].includes(
                                            apartment.details.status_id
                                        )
                                    }"
                                    @mouseenter="
                                        showTooltip(`Apartament ${apartment.details.name}`, [
                                            `Powierzchnia: ${apartment.details.area} m.kw.`,
                                            `Status: ${apartment.details.status}`
                                        ])
                                    "
                                    @mouseleave="hideTooltip"
                                    @mousemove="updateTooltipPosition"
                                    @click="
                                        _ => {
                                            selected_apartment = apartment.id;
                                            changeStep(5);
                                            hideTooltip();
                                        }
                                    "
                                />
                            </template>
                        </svg>
                    </transition>

                    <transition name="flpi-fade">
                        <div
                            class="flpi-layer-tooltip"
                            v-if="tooltip_visible"
                            :style="tooltip_styles"
                            ref="tooltip"
                        >
                            <div class="flpi-layer-tooltip__title">
                                {{ tooltip_title }}
                            </div>
                            <div
                                class="flpi-layer-tooltip__param"
                                v-for="(line, ix) in tooltip_params"
                                :key="ix"
                            >
                                {{ line }}
                            </div>
                        </div>
                    </transition>

                    <div
                        class="flpi-layer__ioverlay"
                        :class="{ 'flpi-layer__ioverlay--active': transition_step_image }"
                    ></div>
                </div>
            </div>
        </div>
        <div class="flpi-footer">
            <a
                class="flpi-footer__link"
                v-if="current_stage"
                @click.prevent="changeStep(2)"
            >
                <!-- {{ current_stage.name }} STG_DISABLED -->
                Wzgórze Poetów
            </a>
            <template v-if="current_building">
                <span class="flpi-footer__separator"> / </span>
                <a
                    class="flpi-footer__link"
                    @click.prevent="changeStep(3)"
                >
                    Budynek {{ current_building.name }}
                </a>
            </template>
            <template v-if="current_floor">
                <span class="flpi-footer__separator"> / </span>
                <a
                    class="flpi-footer__link"
                    @click.prevent="changeStep(4)"
                >
                    {{ current_floor.name }}
                </a>
            </template>
            <template v-if="current_apartment">
                <span class="flpi-footer__separator"> / </span>
                <a
                    class="flpi-footer__link"
                    @click.prevent
                >
                    Apartament {{ current_apartment.details.name }}
                </a>
            </template>
        </div>

        <!-- INITIAL LOADING SCREEN -->
        <transition name="flpi-fade">
            <div
                class="flpi-loading"
                v-if="!data_loaded"
            >
                <div class="flpi-loading__content">
                    <div class="flpi-loading__logo">
                        <img
                            src="data:image/png;base64,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"
                            alt="Logo inwestycji"
                        />
                    </div>
                    <div class="flpi-loading__text">Trwa ładowanie modułu...</div>
                </div>
            </div>
        </transition>
    </div>
    <!-- </div> -->
</template>

<script>
import axios from "axios";

export default {
    name: "App",
    components: {},

    data() {
        return {
            flpi_width: 1400,
            intersection_observer: null,
            data_loading: false,
            data_loaded: false,
            step: 2,

            apartments: [],
            floors: [],
            buildings: [],
            stages: [],
            stages_bg_image: "",

            selected_stage: 1,
            selected_building: null,
            selected_floor: null,
            selected_apartment: null,

            tooltip_title: "",
            tooltip_params: [],
            tooltip_visible: false,
            tooltip_styles: {
                left: 0,
                top: 0
            },

            transition_step_image: false,

            STEP_LABELS: {
                1: "Wybierz etap inwestycji",
                2: "Wybierz budynek",
                3: "Wybierz piętro",
                4: "Wybierz apartament",
                5: "Podgląd apartamentu"
            },
            STEP_GOBACK_DESCS: {
                2: "do wyboru etapu",
                3: "do wyboru budynku",
                4: "do wyboru piętra",
                5: "do wyboru apartamentu"
            }
        };
    },

    computed: {
        layer_image_src() {
            if (this.step === 1) {
                return process.env.VUE_APP_API_URL + this.stages_bg_image;
            } else if (this.step === 2 && this.current_stage) {
                return process.env.VUE_APP_API_URL + this.current_stage.bg_image;
            } else if (this.step === 3 && this.current_building) {
                return process.env.VUE_APP_API_URL + this.current_building.bg_image;
            } else if ((this.step === 4 || this.step === 5) && this.current_floor) {
                return process.env.VUE_APP_API_URL + this.current_floor.bg_image;
            }
            return "";
        },

        current_stage() {
            return this.stages.find(item => item.id == this.selected_stage);
        },
        current_building() {
            return this.buildings.find(item => item.id == this.selected_building);
        },
        current_floor() {
            return this.floors.find(item => item.id == this.selected_floor);
        },
        current_apartment() {
            return this.apartments.find(item => item.id == this.selected_apartment);
        },
        current_apartment_props() {
            if (!this.current_apartment) return;
            const a = [];

            a.push({
                name: "Budynek",
                value: this.current_building.name
            });
            a.push({
                name: "Piętro",
                value:
                    this.current_apartment.details.floor == "0"
                        ? "Parter"
                        : this.current_apartment.details.floor
            });
            a.push({
                name: "Liczba pokoi",
                value: this.current_apartment.details.rooms
            });
            a.push({
                name: "Powierzchnia",
                value: this.current_apartment.details.area + " m.kw."
            });
            if (this.current_apartment.details.balcony != "0") {
                a.push({
                    name: "Balkon",
                    value: this.current_apartment.details.balcony + " m.kw."
                });
            }
            if (this.current_apartment.details.garden != "0") {
                a.push({
                    name: "Ogród",
                    value: this.current_apartment.details.garden + " m.kw."
                });
            }
            if (this.current_apartment.details.terrace != "0") {
                a.push({
                    name: "Taras",
                    value: this.current_apartment.details.terrace + " m.kw."
                });
            }
            a.push({
                name: "Kierunek",
                value: this.current_apartment.details.direction
            });
            a.push({
                name: "Status",
                value: this.current_apartment.details.status
            });

            return a;
        },
        current_apartment_similar_apartments() {
            if (!this.current_apartment) return;
            return this.apartments.filter(item =>
                this.current_apartment.similar_apartments.includes(item.id)
            );
        }
    },

    methods: {
        // change step
        changeStep(step) {
            let tm = 250;

            // dla kroku 5 nie robimy tej animacji
            if (step === 5) {
                this.step = step;
                tm = 1;
            } else {
                this.transition_step_image = true;
            }

            setTimeout(() => {
                this.step = step;
                this.transition_step_image = false;

                if (this.step === 1) {
                    this.selected_stage = null;
                    this.selected_building = null;
                    this.selected_floor = null;
                    this.selected_apartment = null;
                } else if (this.step === 2) {
                    this.selected_building = null;
                    this.selected_floor = null;
                    this.selected_apartment = null;
                } else if (this.step === 3) {
                    this.selected_floor = null;
                    this.selected_apartment = null;
                } else if (this.step === 4) {
                    this.selected_apartment = null;
                }
            }, tm);
        },

        selectAnotherApartment(ap) {
            this.selected_apartment = ap.id;
            this.selected_floor = ap.floor;
            const floor = this.floors.find(item => item.id == ap.floor);
            if (floor) {
                this.selected_floor = floor.id;
                this.selected_building = floor.building;
                const building = this.buildings.find(item => item.id == floor.building);
                if (building) {
                    this.selected_stage = building.stage;
                }
            }
            this.$refs.apartment.scrollTo({
                left: 0,
                top: 0,
                behavior: "smooth"
            });
        },

        // tooltip
        showTooltip(title, params) {
            this.tooltip_visible = true;
            this.tooltip_title = title;
            this.tooltip_params = params;
        },
        hideTooltip() {
            this.tooltip_visible = false;
        },
        updateTooltipPosition(ev) {
            if (!this.$refs.tooltip) return;
            const { left, top } = this.getElementPosition(this.$refs.flpi);
            let ttop = Math.round(ev.clientY - top - this.$refs.header.offsetHeight + 12);

            if (
                ttop + this.$refs.tooltip.offsetHeight >
                this.$refs.flpi.offsetHeight - this.$refs.header.offsetHeight - 36
            ) {
                ttop =
                    this.$refs.flpi.offsetHeight -
                    this.$refs.header.offsetHeight -
                    this.$refs.tooltip.offsetHeight -
                    36;
            }

            this.tooltip_styles = {
                left: Math.round(ev.clientX - left + 12) + "px",
                top: ttop + "px"
            };
        },
        getElementPosition(element) {
            const clientRect = element.getBoundingClientRect();
            return {
                left: clientRect.left + document.body.scrollLeft,
                top: clientRect.top + document.body.scrollTop
            };
        },

        // pobieranie danych z API
        async loadData() {
            if (this.data_loading) return;
            this.data_loading = true;

            try {
                const r = await axios({
                    method: "GET",
                    url: process.env.VUE_APP_API_URL + "/api/flpi/structure"
                });

                this.apartments = r.data.apartments;
                this.floors = r.data.floors;
                this.buildings = r.data.buildings;
                this.stages = r.data.stages;
                this.stages_bg_image = r.data.stages_bg_image;

                await this.waitForMs(1500);

                this.data_loaded = true;
            } catch (err) {
                console.error(err);
            }

            this.data_loading = false;
        },

        // ładowanie po wjechaniu modułu w viewport
        onIntersectionObserverIntersect(entries) {
            if (entries[0].isIntersecting && !this.data_loaded && !this.data_loading) {
                this.loadData();
            }
        },

        waitForMs(ms) {
            return new Promise(res => {
                setTimeout(res, ms);
            });
        },

        doCalcs() {
            this.flpi_width = this.$refs.flpi.offsetWidth;
        }
    },

    mounted() {
        this.intersection_observer = new IntersectionObserver(
            this.onIntersectionObserverIntersect,
            {
                threshold: 0.1
            }
        );
        this.intersection_observer.observe(this.$refs.flpi);

        this.doCalcs();
        window.addEventListener("resize", this.doCalcs);
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.doCalcs);
    }
};
</script>

<style lang="scss">
$FONT_WEIGHT_REGULAR: 400;
$FONT_WEIGHT_BOLD: 700;

// html {
//     font-size: 15px;
//     line-height: 24px;

//     font-family: "Figtree", sans-serif;
//     font-display: swap;
//     font-weight: $FONT_WEIGHT_REGULAR;
//     color: #0a0b0e;

//     scroll-behavior: smooth;
// }

// body {
//     margin: 0;
//     padding: 0;

//     min-width: 320px;
//     overflow-x: hidden;
//     background-color: #ededed;
// }

// .cont {
//     max-width: 1400px;
//     margin: 0 auto;
//     padding: 120px 0;
// }

.flpi {
    position: relative;
    box-sizing: border-box;

    * {
        box-sizing: border-box;
    }

    &-header {
        // background-color: black;
        padding: 8px 0;
        min-height: 68px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: white;

        &-stepper {
            display: flex;
            align-items: flex-end;
            margin-right: 24px;

            &__step {
                font-weight: $FONT_WEIGHT_BOLD;
                font-size: 20px;
                line-height: 20px;
            }

            &__stepname {
                margin-left: 8px;
                line-height: 1rem;
                font-size: 1rem;
            }
        }

        &-goback {
            &__name {
                font-weight: $FONT_WEIGHT_BOLD;
                text-transform: uppercase;
                letter-spacing: 0.4px;
            }
            &__desc {
                font-size: 13px;
                line-height: 13px;
            }
        }
    }

    &__container {
        padding-bottom: 43%;
        position: relative;
    }
    &__display {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: white;
        overflow-y: auto;
    }

    &-layer {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;

        &__image {
            position: relative;

            &--blurred {
                &::after {
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    backdrop-filter: blur(50px);
                    background-color: rgba(255, 255, 255, 0.1);
                }
            }

            img,
            svg {
                display: block;
                width: 100%;
            }
        }
        &__ioverlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(255, 255, 255, 0.8);
            transition: opacity 0.25s ease;
            backdrop-filter: blur(16px);
            opacity: 0;
            pointer-events: none;

            &--active {
                opacity: 1;
            }
        }

        &__svg,
        &__stages,
        &-apartment {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }

        &__stages {
            display: flex;
        }
        &-stage {
            flex: 1;
            padding: 24px;
            display: flex;
            align-items: center;
            justify-content: center;

            &__card {
                padding: 24px;
                background-color: white;
                border-radius: 12px;
                min-width: 180px;
                text-align: center;
            }

            &__name {
                margin-bottom: 24px;
                font-weight: $FONT_WEIGHT_BOLD;
                font-size: 28px;
                line-height: 36px;
            }
        }

        &-apartment {
            background-color: white;
            overflow-y: auto;
            padding: 0px 24px 24px;

            &__header {
                position: sticky;
                top: 0;
                padding-bottom: 8px;
                padding-top: 24px;
                margin-bottom: 32px;
                border-bottom: 1px solid #f2f2f2;
                background-color: white;
                z-index: 2;
            }

            &__name {
                margin: 0;
                font-weight: $FONT_WEIGHT_BOLD;
                font-size: 32px;
                line-height: 32px;
            }
            &__goback {
                margin-top: 8px;
                margin-left: -8px;
                display: flex;
                align-items: center;
                color: #717681;
                font-size: 13px;
                line-height: 20px;
                cursor: pointer;

                svg {
                    width: 20px;
                    margin-right: 4px;
                }
            }

            &__heading {
                margin: 0;
                margin-bottom: 24px;
                font-weight: $FONT_WEIGHT_BOLD;
                font-size: 20px;
                line-height: 28px;
                color: #444b5f;
                position: relative;

                &::after {
                    content: "";
                    position: absolute;
                    display: block;
                    left: 0;
                    top: calc(100% + 4px);
                    width: 200px;
                    max-width: 100%;
                    height: 1px;
                    background: linear-gradient(0.25turn, #e5cf9f, rgba(229, 207, 159, 0));
                }
            }

            &__details {
                display: flex;
                justify-content: space-between;

                &--mobile {
                    display: block;
                }
            }
            &__info,
            &__card {
                width: calc(50% - 12px);

                &--mobile {
                    width: 100%;
                }
            }

            &__card {
                &--mobile {
                    margin-top: 32px;
                }
            }

            &__props {
                display: flex;
                flex-wrap: wrap;
                width: calc(100% + 16px);
                margin: -8px;
            }
            &__propcol {
                width: 50%;
                padding: 8px;
            }
            &-prop {
                &__name {
                    font-size: 13px;
                    line-height: 17px;
                    margin-bottom: 4px;
                }
                &__value {
                    font-weight: $FONT_WEIGHT_BOLD;
                    font-size: 18px;
                    line-height: 24px;
                    color: #444b5f;
                }
            }

            &-plan {
                &__image {
                    padding-bottom: 40%;
                    position: relative;

                    img,
                    svg {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        object-position: center top;
                    }
                }

                &__btn {
                    display: flex;
                    align-items: center;
                    margin-top: 8px;
                    background-color: #0a0b0e;
                    color: white;
                    padding: 4px 12px;
                    justify-content: center;
                    text-decoration: none;

                    svg {
                        width: 20px !important;
                        margin-right: 8px;
                    }
                }
            }

            &__similar {
                margin-top: 32px;
            }
            &__simgrid {
                display: flex;
                flex-wrap: wrap;
                width: calc(100% + 16px);
                margin: -8px;
            }
            &__simcol {
                width: 25%;
                padding: 8px;

                &--mobile {
                    width: 50%;
                }
            }
            &-simap {
                padding: 12px;
                background-color: #fbf8ef;
                border-radius: 4px;
                cursor: pointer;

                &__name {
                    font-weight: $FONT_WEIGHT_BOLD;
                    margin-bottom: 12px;
                    padding-bottom: 4px;
                    font-size: 15px;
                    line-height: 15px;
                    position: relative;

                    &::after {
                        content: "";
                        position: absolute;
                        display: block;
                        left: 0;
                        top: calc(100% + 4px);
                        width: 100px;
                        max-width: 100%;
                        height: 1px;
                        background: linear-gradient(0.25turn, #e5cf9f, rgba(229, 207, 159, 0));
                    }
                }

                &__prop {
                    font-size: 13px;
                    line-height: 19px;
                    color: #717681;
                }

                &__cta {
                    margin-top: 8px;
                    text-align: right;
                    font-size: 11px;
                    line-height: 11px;
                    text-transform: uppercase;
                    color: #ca9e3f;
                }
            }
        }

        &-tooltip {
            position: absolute;
            padding: 12px;
            background-color: white;
            border-radius: 4px;
            top: 0;
            left: 0;

            &__title {
                font-weight: $FONT_WEIGHT_BOLD;
                margin-bottom: 4px;
            }
            &__param {
                font-size: 13px;
                line-height: 19px;
                color: #717681;
            }
        }
    }

    &-svg {
        &__polygon {
            fill: #0a0b0e;
            transition: opacity 0.2s ease;
            opacity: 0;

            &:hover {
                opacity: 0.7;
                cursor: pointer;
            }

            &--success {
                fill: #0e6640;
            }

            &--halfvisible {
                opacity: 0.3;
            }
        }
    }

    &-footer {
        padding: 4px 0;
        font-size: 13px;
        line-height: 19px;
        color: white;

        &__separator {
            display: inline-block;
            margin: 0px 4px;
        }

        &__link {
            &:not(:last-child):hover {
                text-decoration: underline;
                cursor: pointer;
            }
        }
    }

    &-loading {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 10;
        background-color: #edf7ec;
        padding: 32px;
        display: flex;
        align-items: center;
        justify-content: center;

        &__logo {
            width: 128px;
            margin-bottom: 24px;
            margin-left: auto;
            margin-right: auto;
            animation: flpi-loading-logo 2s infinite;

            img,
            svg {
                display: block;
                width: 100%;
            }
        }
    }

    &-btn {
        font-family: inherit;
        font-size: 1rem;
        background: none;
        border: none;
        outline: none;
        cursor: pointer;
        display: inline-block;
        padding: 8px 16px;
        transition: all 0.3s ease;
        border-radius: 2px;
        text-align: center;
        color: white;

        &-primary {
            position: relative;
            overflow: hidden;
            z-index: 2;
            background-color: #4dad45;

            &::before {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                content: "";
                display: block;
                -webkit-transform: translateX(-100%);
                transform: translateX(-100%);
                -webkit-transition: all 0.5s ease;
                transition: all 0.5s ease;
                z-index: -2;
                opacity: 0.5;
                background-color: #3b8334;
            }

            &:hover {
                &::before {
                    transform: translateX(50%) scale(2);
                }
            }

            &:disabled {
                cursor: not-allowed;
                opacity: 0.2;

                &::before {
                    background: #4a5f44 !important;
                }
                &::after {
                    display: none !important;
                }
            }
        }
    }

    // ANIMACJE
    &-fade-enter-active,
    &-fade-leave-active {
        transition: opacity 0.2s;
    }
    &-fade-enter,
    &-fade-leave-to {
        opacity: 0;
    }

    @keyframes flpi-loading-logo {
        0%,
        100% {
            opacity: 1;
        }
        50% {
            opacity: 0.2;
        }
    }
}
</style>
